export const getErrorInfo = (error: any) => {
  if ((error.response && error.response.status) === 500) {
    return 'There is a server error, Please contact admin. Code 500.';
  }

  if ((error.response && error.response.status) === 422) {
    return error.response.data.detail;
  }

  if ((error.response && error.response.status) === 400) {
    //if the object 'error' occurs, then likely dealing with array of error. we show the first one
    if (error.response.data.errors) {
      const responseErrors = error.response.data.errors;
      const allErrors = Object.values(responseErrors)[0];

      if (Array.isArray(allErrors)) {
        return allErrors[0];
      } else {
        return responseErrors;
      }
    }

    if (error.response.data.detail) {
      return error.response.data.detail;
    }
  }

  if ((error.response && error.response.status) === 404) {
    return error.response.data.detail;
  }

  if ((error.response && error.response.status) === 409) {
    return error.response.data.detail;
  }

  if ((error.response && error.response.status) === 403) {
    return 'You do not have permission to perform this action';
  }

  if ((error.response && error.response.status) === 401) {
    return 'You are not authorized to perform this action';
  }
};
